import React, {useState, useEffect} from "react";
import "../style/product/product.css";
import {ThemeProvider, makeStyles} from "@mui/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Link} from "react-router-dom";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import {createTheme, Grid} from "@mui/material";
import NL1HubApp from '../components/AboutPage/images/NL1Hub App.png';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
}));

const theme = createTheme({
    palette: {
        primary: {
            main: "#BC7200",
        },
        secondary: {
            main: "#6750a4",
        },
    },
});

function ProductOld() {
    const [learnMore, setLearnMore] = useState(false);

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [carouselNumber, setCarouselNumber] = useState(0);

    const classes = useStyles();

    const checkLogin = () => {
        if (localStorage.getItem('AUTHORIZATION_TOKEN_BLOG')) {
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false);
        }
    };

    useEffect(() => {
        checkLogin();
    }, []);

    return (
        <div className="container">
            <div className="productContainer">
                <div className="nlc-gallery">
                    <img className="nlc-logo" alt="nlc-logo" src="NLCLogo.png"/>
                    <img className="nlc-name" alt="nlc-name" src="NLCName.png"/>
                </div>
                <Typography variant="h4">
                    Breakthrough Multi-Sensory Assessment & Intervention Tool With AI
                </Typography>
                <br/>
                <br/>
                <div className="productContainerRow">
                    <Typography className="productText" variant="body1">
                        <Typography variant="h6" style={{marginBottom: "2rem"}}>
                            Our Solution Optimizes Learning
                        </Typography>
                        <ul>
                            <li>
                                NeuroLeap replaces the current paper-based, labor-intensive, and legacy methods with a
                                comprehensive 3-pronged solution: <br/>
                                (1) Cloud-based AI for auto-correlate results and report generation, <br/>
                                (2) a customized computer system, and <br/>
                                (3) sensor modules.
                            </li>
                            <li>
                                Areas covered:
                                <ul>
                                    <li>
                                        Speech & Language (Auditory Comprehension & Expressive Communication incl.
                                        Articulation)
                                    </li>
                                    <li>Reading & Writing (Dyslexia, Dysgraphia, etc.)</li>
                                    <li>Motor Skills (Gross Motor and Fine Motor Skills)</li>
                                    <li>Core Cognitive Skills (IQ)</li>
                                    <li>Mental Health/Emotional Intelligence (EQ)</li>
                                </ul>
                            </li>
                        </ul>
                    </Typography>
                    <div className={'productContainerColumn'}>
                        <div className="productImageContainer">
                            <img className="productImage" src="neuro_leap_website-1.png" alt="product"/>
                            <div className="caption">
                            </div>
                        </div>
                        <Typography className="productText" variant="body1">
                            <Typography variant="h6" style={{marginBottom: "2rem"}}>
                                Multi-symptom Assessment and Treatment
                            </Typography>
                            <ul>
                                <li>
                                    Stimulates several developing areas in the body (heart, brain, kinesiology) using
                                    EEG sensors and other biosensors
                                </li>
                            </ul>
                        </Typography>
                    </div>
                </div>
                <br/>
                <div className="productContainerRow">
                    <Typography className="productText" variant="body1">
                        <Typography variant="h6" style={{marginBottom: "2rem"}}>
                            Our Solution Demonstrates Better Cost Effectiveness
                        </Typography>
                        <ul>
                            <li>
                                Using legacy methods, one specialist is required for a one-on-one in-person diagnosis
                                while another specialist manages one-on-one in-person intervention phase. Our solution
                                assists a specialist to both diagnose and provide intervention, locally and/or remotely,
                                for a range of conditions, as mentioned below
                            </li>
                            <li>
                                In addition to the initial screening phase, NeuroLeap also condenses above two phases
                                and thereby expedites diagnosis and intervention, locally or remotely, at a
                                significantly lower cost
                            </li>
                        </ul>
                    </Typography>
                    <Typography className="productText" variant="body1">
                        <Typography variant="h6" style={{marginBottom: "2rem"}}>
                            Our Solution Finds the Root Cause Effectively and Fast
                        </Typography>
                        <ul>
                            <li>
                                NeuroLeap gives all children a better chance to maximize their potential, regardless of
                                the nature of their challenge(s). NeuroLeap's disruption comes from using a suite of
                                sensor modules for multi-sensory integration, combined with gamified AI-empowered
                                dynamic assessment and fine-tuned intervention. As children are complex and in the
                                majority of cases, they have multiple symptoms that confuses the Specialists. Our
                                solution focuses on accurately finding the root cause, and helps in providing a more
                                efficient intervention. This creates an optimal learning experience that is adapted for
                                each child, and builds upon a continual series of improvements. The technology inside
                                the solution is only half the story; the other half of the revolution is that children
                                actually love to play and learn with our AI-powered solution!
                            </li>
                        </ul>
                    </Typography>
                </div>
                <br/>
                <br/>
                <div className="productContainerRow">
                    <div className={'productContainerColumn'}>
                        <div className="productImageContainer">
                            <img className="productImage" src="neuro_leap_website-2.png" alt="product"/>
                            <div className="caption">
                            </div>
                        </div>
                        <Typography className="productText" variant="body1">
                            <Typography variant="h6" style={{marginBottom: "2rem"}}>
                                Our Solution Offers Earliest Intervention
                            </Typography>
                            <ul>
                                <li>
                                    Engaging—Stimulate many senses with physical objects & interactive multimedia
                                    stories
                                </li>
                                <li>
                                    Objective—Administer, instruct, and track activities objectively, and would be
                                    normed.
                                </li>
                            </ul>
                        </Typography>
                    </div>
                    <Typography className="productText" variant="body1">
                        <Typography variant="h6" style={{marginBottom: "2rem"}}>
                            Operational - Management & Accessibility
                        </Typography>
                        <ul>
                            <li>
                                Offer security & privacy—Patient records are kept securely & integrates with EMR systems
                            </li>
                            <li>
                                Results are auto-correlated—Shown as easy-to-understand graphs & tables
                            </li>
                            <li>
                                Complies to existing scales—Reports can be auto-generated anywhere
                            </li>
                            <li>
                                Accessible & portable—From remote location instant assessment, intervention, and
                                monitoring capability
                            </li>
                            <li>
                                Durable and battery operated—Can perform without the need of cellular service and
                                wired/wireless internet connectivity
                            </li>
                        </ul>
                    </Typography>
                </div>
                <br/>
                <div className="productContainerRow">
                    <Typography className="productText" variant="body1">
                        <Typography variant="h6" style={{marginBottom: "2rem"}}>
                            Addressing Critical Challenges for Over a Billion People
                        </Typography>
                        <ul>
                            <li>
                                Over 1 billion people have learning differences, motor skills impairment and/or related
                                neurological disabilities/conditions
                            </li>
                            <li>
                                Dyslexia, language disorders & motor skills impairment are foundational problems for
                                children
                            </li>
                            <li>
                                Just counting learning differences: One-in-five of US children (12.4M)
                            </li>
                            <li>
                                A majority (7.4M or 60%) of these children have multiple conditions
                            </li>
                        </ul>
                    </Typography>
                    <div className={'productContainerColumn'}>
                        <div className="productImageContainer">
                            <img className="productImage" src="kayley3.png" alt="product"/>
                            <div className="caption">
                            </div>
                        </div>
                        <Typography className="productText" variant="body1">
                            <Typography variant="h6" style={{marginBottom: "2rem"}}>
                                Motivation & Work Offload - Efficiency Gains
                            </Typography>
                            <ul>
                                <li>
                                    Motivates—Instantly adjusts the difficulty level and encourages participation.
                                </li>
                                <li>
                                    Recognizes and responds to child—Accurate speech recognition
                                </li>
                                <li>
                                    Auto-suggest changes—Instant re-assessment & treatment/intervention adjustment
                                </li>
                            </ul>
                        </Typography>
                    </div>

                </div>
                <br/>
                <div className="productButtons">
                    <ThemeProvider theme={theme}>
                        <>
                            <Link to="contact">
                                <Button variant="contained" color="secondary" className="contactButton">
                                    Contact Us
                                </Button>
                            </Link>
                        </>
                        <Button variant="contained" color="secondary" className="learnMoreButton"
                                onClick={() => setLearnMore(!learnMore)} disabled={!isLoggedIn}>
                            {isLoggedIn ? "Learn More" : "Login to Learn More"}
                        </Button>
                    </ThemeProvider>
                </div>
                {learnMore && (
                    <>
                        <br/>
                        <br/>
                        <Typography variant="h4">
                            Detailed Skill Areas
                        </Typography>
                        <br/>
                        <div className={'advancedProductsRow'}>
                            <div className={'advancedProductsColumn'}>
                                <Typography variant="h6">Assessment Overview</Typography>
                                <br/>
                                <Typography variant="body1">
                                    NeuroLeap's comprehensive assessment tools go beyond traditional paper-based methods
                                    to provide detailed, objective evaluations across multiple developmental domains.
                                    Using advanced sensor technology and AI analysis, our assessments capture nuanced
                                    data about a child's abilities in areas such as attention, memory, motor coordination,
                                    and language processing.
                                </Typography>
                                <div className="imageBox">
                                    <img
                                        className="productImageAdvanced"
                                        src="child-reading.png"
                                        alt="product"
                                    />
                                </div>
                            </div>
                            <div className={'advancedProductsColumn'}>
                                <Typography variant="h6">Intervention Programs</Typography>
                                <br/>
                                <Typography variant="body1">
                                    Our intervention and training modules provide personalized, adaptive learning
                                    experiences tailored to each child's unique needs and abilities. The gamified
                                    approach keeps children engaged while systematically building skills in areas
                                    of difficulty. The system continuously monitors progress and automatically
                                    adjusts difficulty levels.
                                </Typography>
                                <div className="imageBox">
                                    <img
                                        className="productImageAdvanced"
                                        src="child-reading.png"
                                        alt="product"
                                    />
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div className={'advancedProductsRow'}>
                            <img
                                className="productImageAdvanced"
                                src={NL1HubApp}
                                alt="product"
                            />
                        </div>
                        <br/>
                        <hr></hr>
                        <br/>
                        <Typography variant="h6">
                            Some of the areas that the applications cover:
                        </Typography>
                        <br/>
                        <div className="carouselButtons">
                            <ThemeProvider theme={theme}>
                                <Popup
                                    trigger={
                                        <Button variant="contained" color="secondary" className="carouselButton"
                                                onClick={() => setCarouselNumber(0)}>
                                            Screening/Mini-Test
                                        </Button>
                                    }
                                    modal
                                >
                                    <div>
                                        <Typography variant="h6">Screening/Mini-Test</Typography>
                                        <br/>
                                        <Typography variant="body1">
                                            NeuroLeap's screening module provides a quick, efficient way to identify
                                            potential learning differences and developmental delays. Our AI-powered
                                            mini-tests are designed to be engaging for children while providing
                                            clinicians with valuable preliminary data. The screening process covers
                                            multiple domains including cognitive abilities, motor skills, and language
                                            development, allowing for early identification of areas that may require
                                            further assessment or intervention.
                                        </Typography>
                                    </div>
                                </Popup>
                                <Popup
                                    trigger={
                                        <Button variant="contained" color="secondary" className="carouselButton"
                                                onClick={() => setCarouselNumber(1)}>
                                            Assessment
                                        </Button>
                                    }
                                    modal
                                >
                                    <div>
                                        <Typography variant="h6">Assessment</Typography>
                                        <br/>
                                        <Typography variant="body1">
                                            Our comprehensive assessment tools go beyond traditional paper-based methods
                                            to provide detailed, objective evaluations across multiple developmental
                                            domains. Using advanced sensor technology and AI analysis, NeuroLeap
                                            assessments capture nuanced data about a child's abilities in areas such
                                            as attention, memory, motor coordination, and language processing. Results
                                            are automatically correlated and presented in easy-to-understand reports,
                                            enabling clinicians to develop targeted intervention strategies.
                                        </Typography>
                                    </div>
                                </Popup>
                                <Popup
                                    trigger={
                                        <Button variant="contained" color="secondary" className="carouselButton"
                                                onClick={() => setCarouselNumber(2)}>
                                            Intervention/Training
                                        </Button>
                                    }
                                    modal
                                >
                                    <div>
                                        <Typography variant="h6">Intervention/Training</Typography>
                                        <br/>
                                        <Typography variant="body1">
                                            NeuroLeap's intervention and training modules provide personalized, adaptive
                                            learning experiences tailored to each child's unique needs and abilities.
                                            Our gamified approach keeps children engaged while systematically building
                                            skills in areas of difficulty. The system continuously monitors progress
                                            and automatically adjusts difficulty levels to maintain optimal challenge.
                                            Real-time feedback helps clinicians track improvement and make data-driven
                                            decisions about treatment modifications.
                                        </Typography>
                                    </div>
                                </Popup>
                            </ThemeProvider>
                        </div>
                        <br/>
                        <br/>
                        <div className={classes.root}>
                            {/*-----------------------Core Cognitive Skills--------------------------*/}
                            <div>
                                <Typography variant="h4">
                                    Core Cognitive Skills
                                    <br/>
                                    <br/>
                                </Typography>
                                {/* Logic and Reasoning */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Logic and Reasoning
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Deductive
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Inductive
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Perception */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Perception
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Visual
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Auditory
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Perception Speed
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Memory */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Memory
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Long-Term
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Short-Term
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Sensory
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Working
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Attention */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Attention
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Selective
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Sustained
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Divided
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <br/>
                            <br/>
                            {/*----------------Interpersonal Skills & Identifiable Emotions-----------*/}
                            {/* Interpersonal Skills */}
                            <div>
                                <Typography variant="h4">
                                    Interpersonal Skills
                                    <br/>
                                    <br/>
                                </Typography>
                                {/* Motivation */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Motivation
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                Consists of doing what you enjoy, working towards achieving goals,
                                                and not being motivated by money or status
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Social Skills */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Social Skills
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                Effective at managing relationships that benefits everyone involved
                                                (ex: confidence, communication, cooperation)
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Empathy */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Empathy
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                Able to identify and understand other's emotions
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Self Awareness */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Self Awareness
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                The ability to recognize your own emotions, strengths, and limitations,
                                                and their impact on others around you
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Self Regulation */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Self Regulation
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                Allows you to wisely manage your emotions and impulses
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <br/>
                            <br/>
                            {/* Identifiable Emotions */}
                            <div>
                                <Typography variant="h4">
                                    Identifiable Emotions
                                    <br/>
                                    <br/>
                                </Typography>
                                {/* Trust */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Trust
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                Assured reliance on the character, ability, strength, or truth of
                                                someone or something
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Happiness */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Happiness
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                An emotional state characterized by feelings of joy, satisfaction
                                                contentment, and fullfillment
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Relation to Self */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Relation to Self
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                Emotional stimuli attract attention because of their high
                                                motivational relevance for the observer's wellbeing and survival
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Anger */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Anger
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                An emotion characterized by antagonism toward someone or something
                                                you feel has deliberately done you wrong
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Stress */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Stress
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                A state of mental or emotional strain or tension resulting
                                                from adverse or very demanding circumstances
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Jealousy */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Jealousy
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                Thoughts or feelings of insecurity, fear, and concern over a
                                                relative lack of possessions or safety
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <br/>
                            <br/>
                            {/*-----------------------Motor Skills--------------------------*/}
                            {/* Gross Motor */}
                            <div>
                                <Typography variant="h4">
                                    Gross Motor
                                    <br/>
                                    <br/>
                                </Typography>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>Reflexes</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">Newborn Reflexes</Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">Reactions</Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Motor reflex (patellar reflex)
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Stationary
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Head/trunk
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Sitting and standing
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Movements
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Basic exercises
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Range of motion
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Locomotion
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Leg movement
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Turning movement
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Arm movement
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Crawling, Walking, Running
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Standing and Jumping
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Rolling
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <br/>
                            <br/>
                            {/* Fine Motor */}
                            <div>
                                <Typography variant="h4">
                                    Fine Motor
                                    <br/>
                                    <br/>
                                </Typography>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Visual motor integration
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Paper manipulation
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Cube/pellet manipulation
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Tracking objects
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Grasping
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Touching
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Grab & release
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Shaking, pulling
                                                </Typography>
                                            </li>
                                            <li>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel2a-content"
                                                        id="panel2a-header"
                                                    >
                                                        <Typography className={classes.heading}>
                                                            Self care tasks
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <ul>
                                                            <li>
                                                                <Typography variant="body1">Buttoning</Typography>
                                                            </li>
                                                            <li>
                                                                <Typography variant="body1">
                                                                    Tying/untying shoes
                                                                </Typography>
                                                            </li>
                                                            <li>
                                                                <Typography variant="body1">
                                                                    Utensil manipulation
                                                                </Typography>
                                                            </li>
                                                        </ul>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </li>
                                            <li>
                                                <Typography variant="body1">Writing/drawing</Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">Cutting paper</Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <br/>
                            <br/>
                            {/*-------------------Reading & Writing Skills---------------------*/}
                            {/* Reading Skills */}
                            <div>
                                <Typography variant="h4">
                                    Reading Skills
                                    <br/>
                                    <br/>
                                </Typography>
                                {/* Word Construction */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Word Construction
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Ability to divide words into syllables for written words
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Ability to count syllables in words read orally
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Adding prefixes to words (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Adding suffixes to words (Adv.)
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Word Detection & Pattern Recognition */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Word Detection & Pattern Recognition
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Ability to listen to words orally and name the beginning sounds
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Ability to recognize and pronounce beginning consonants when
                                                    presented with a list of on a computer screen
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Ability to recognize beginning consonants when presented
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Letter Recognition */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Letter Recognition
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Lowercase Letters
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Uppercase Letters
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Speaking & Sounding Out */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Speaking & Sounding Out
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Ability to pronounce final consonants in spoken words
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Reciting the alphabet
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Ability to say last letter of the word
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Reading 3 words that rhyme/word families (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Orally reading words with diphthongs and digraphs (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Sounding out blends in initial position of words (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Reading words that are irregular to English (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Able to sound out nonsense words with the long vowels having the
                                                    final e and able to give the final e rule (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Able to sound out short vowel words a, e, i, o, and u
                                                    using nonsense words (Adv.)
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <br/>
                            <br/>
                            {/* Writing Skills */}
                            <div>
                                <Typography variant="h4">
                                    Writing Skills
                                    <br/>
                                    <br/>
                                </Typography>
                                {/* Handwriting */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Handwriting
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Forming lowercase and uppercase letters correctly
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Developing fine motor skills so that they can use a range of
                                                    tools competently, safely, and confidently
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Developing the foundations of a handwriting style which is
                                                    fast, accurate, and efficient (Adv.)
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Spelling */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Spelling
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Spelling the days of the week
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Spelling some taught common expectation, high frequency,
                                                    and familiar words
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Using letter names to distinguish between alternative
                                                    spellings of the same sound (Adv.)
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Grammatical Terminology */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Grammatical Terminology
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Knowing the meaning of "punctuation"
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Knowing the meaning of "sentence"
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Knowing the meaning of "plural" (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Knowing the meaning of "singular" (Adv.)
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Finding Mistakes */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Finding Mistakes
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Discussing what they have written with the teachers or other pupils
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Ensuring verbs are used to indicate time correctly
                                                    and consistently, including verbs in the continuous form (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Checking written work by reading and
                                                    make changes when necessary (Adv.)
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Sentence Structure */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Sentence Structure
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Thinking of, saying, and writing a simple sentence, sometimes
                                                    using a capital letter and full stop
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Organizing paragraphs around a theme (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Selecting appropriate grammar and vocabulary and
                                                    understanding how such choices can change and enhance meaning (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Creating settings, characters, and plot in narratives (Adv.)
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Context/Content */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Context/Content
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Writing about personal experiences and those of others
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Writing about real events (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Writing poetry (Adv.)
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Writing for different purposes (Adv.)
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <br/>
                            <br/>
                            {/*-------------------Receptive Language---------------------*/}
                            <div>
                                <Typography variant="h4">
                                    Receptive Language
                                    <br/>
                                    <br/>
                                </Typography>
                                {/* Attention to Environment */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Attention to Environment
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Auditory Localization
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Attends to gestures on the screen
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Attends to gestures from caregiver
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Auditory Perception */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Auditory Perception
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Attending to names
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Attending to object names
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Functional play
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Interact with Environment */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Interact with Environment
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Mouths or bangs objects
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Attention to people */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Attention to people
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Anticipation
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Syntax */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Syntax
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    That is sleeping
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    That is not black
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Understands sentences post noun elaboration - that is in the box
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Understands complex sentences with modifiers
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Problem Solving Skills */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Problem Solving Skills
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Attending to names
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Attending to object names
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Functional Play
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Analogies */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Analogies
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Sleep/sit
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Eat/cut
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Hear/see
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Idioms
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Preposition */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Preposition
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Spatial Concepts: under, in, back, next to, in front of
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Pragmatics */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Pragmatics
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Theory of mind - understands false beliefs
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Inferencing */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Inferencing
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    How messy
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    How wet
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    How tired
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Morphologies */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Morphologies
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Not crying - negative
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    No eggs
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Not in box
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Pronouns: her his, she, he, they
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Judging correct grammar
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Auditory Discrimination */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Auditory Discrimination
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Identifies initial sounds
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <br/>
                            <br/>
                            {/* Expressive Language */}
                            <div>
                                <Typography variant="h4">
                                    Expressive Language
                                    <br/>
                                    <br/>
                                </Typography>
                                {/* Vocal Development */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Vocal Development
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Different types of vocalization
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Babbling
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Gesture */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Gesture
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Representational Gesture
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Vocabulary Development
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Articulation */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Articulation
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    The ability to physically move the tongue, lips, teeth,
                                                    and jaw to produce sequences of speech sounds.
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Semantics */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Semantics
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Language
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Label items using words
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Vocabulary, Vocabulary development, and Vocabulary-connected speech
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Connected Speech
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Qualitative, Quantitative, Spatial, and Time-Sequence Concepts
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Language Structure */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Language Structure
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Syntax, Syntax-regular plurals, and Syntax-present progressive verbs
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Morphology
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Integrative Language Skills */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Integrative Language Skills
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Matching objects to descriptions
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Function of objects
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Abstract language
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Analogies
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Semantic absurdities
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Answering with questions
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Similes
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Synonyms
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Similarities
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Emergent Literary Skills*/}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Emergent Literary Skills
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Letter identification
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Rhyming
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Syllables
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Repetition
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Retells story
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Social Communication */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Social Communication
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Facial recognition
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Different types of vocalization
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Request repetition
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Play
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Pragmatics / making requests and comments
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Request assistance
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                                <br/>
                                {/* Morphology */}
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Morphology
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Grammar
                                                </Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <br/>
                            <br/>
                            {/* Technology Integration */}
                            <div>
                                <Typography variant="h4">
                                    Technology Integration
                                    <br/>
                                    <br/>
                                </Typography>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            Technology Integration
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul>
                                            <li>
                                                <Typography variant="body1">
                                                    Electromyography (EMG), Electroencephalogram (EEG), and
                                                    Electrocardiogram (ECG) sensors
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">
                                                    Goniometer and motion analysis devices
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">Pinch gauges/meters</Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body1">Dynamometers</Typography>
                                            </li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default ProductOld;
